const Colors = {
    primary: '#1976D2',
    secondary: '#424242',
    accent: '#FFC107',
    background: '#F5F5F5',
    surface: '#FFFFFF',
    error: '#D32F2F',
    errorBg:'#FFDAD6',
    errorText:'#BA1A1A',
    warning: '#FFA000',
    info: '#0288D1',
    success: '#388E3C',
    successBg:'#C9F0D6',
    textPrimary: '#212121',
    textSecondary: '#757575',
    border: '#E0E0E0',
    disabled: '#BDBDBD',
    warningBg:'#FEF0D8',
    warningBorder:'#FBB33A',
    warningText:'#4C3600'
};

export default Colors;